export default __webpack_public_path__ + "static/media/arrowBackIcon.dee96783.svg";